// Display name for a truck's driver or passenger seat, from the
// driver_* / passenger_* columns that GET /api/routes/trucks returns.
// TKT-281: falls back to the username, so a filled seat never reads as empty
// just because the user has no first/last name.
export const crewSeatName = (truck, seat) => {
  if (!truck) return null;
  const full = `${truck[`${seat}_first_name`] || ''} ${truck[`${seat}_last_name`] || ''}`.trim();
  return full || truck[`${seat}_username`] || null;
};
